import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Box, Button, Tooltip } from "@mui/material";
import PublicIcon from "@mui/icons-material/Public";
import VideocamIcon from "@mui/icons-material/Videocam";

const systems = [
  {
    id: "network",
    label: "Network",
    path: "/site/dashboard",
    Icon: PublicIcon,
    activeColor: "#172664",
  },
  {
    id: "surveillance",
    label: "Surveillance",
    path: "/surveillance/dashboard",
    Icon: VideocamIcon,
    activeColor: "#0C8CE9",
  },
];

const getFirstMenuPath = (systemId) => {
  try {
    const selectedBreadcrumbs = JSON.parse(
      localStorage.getItem("selectBreadcrumbs") || "{}",
    );

    if (selectedBreadcrumbs?.site?.id) {
      return systemId === "surveillance"
        ? "/surveillance/dashboard"
        : "/site/dashboard";
    }

    const isMspScope =
      selectedBreadcrumbs?.realm?.hasManageOrg === true &&
      !selectedBreadcrumbs?.orgs?.id;

    if (isMspScope) return "/msp/organizations";

    return "/org/sites";
  } catch {
    return systemId === "surveillance"
      ? "/surveillance/dashboard"
      : "/site/dashboard";
  }
};

export default function SystemSwitcher() {
  const location = useLocation();
  const navigate = useNavigate();
  const [selectedSystem, setSelectedSystem] = useState(
    localStorage.getItem("selectedSystem") || "network",
  );
  const activeSystem = location.pathname.startsWith("/surveillance")
    ? "surveillance"
    : selectedSystem;

  useEffect(() => {
    if (location.pathname.startsWith("/surveillance")) {
      setSelectedSystem("surveillance");
      localStorage.setItem("selectedSystem", "surveillance");
      return;
    }

  }, [location.pathname]);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "stretch",
        alignSelf: "stretch",
        ml: 3,
        borderLeft: "1px solid",
        borderRight: "1px solid",
        borderColor: "primary.borderGreyPrimary",
      }}
    >
      {systems.map(({ id, label, Icon, activeColor }) => {
        const isActive = activeSystem === id;

        return (
          <Tooltip title={label} key={id}>
            <Button
              onClick={() => {
                setSelectedSystem(id);
                localStorage.setItem("selectedSystem", id);
                window.dispatchEvent(new Event("selectedSystemChange"));

                navigate(getFirstMenuPath(id));
              }}
              sx={{
                minWidth: isActive ? 160 : 58,
                px: isActive ? 2 : 1.5,
                borderRadius: 0,
                color: isActive ? "primary.greyPrimary" : "primary.greySixth",
                bgcolor: isActive ? "primary.whiteSecound" : "primary.white",
                gap: 1,
                fontSize: 14,
                fontWeight: isActive ? 600 : 500,
                textTransform: "none",
                borderRight: "1px solid",
                borderColor: "primary.borderGreyPrimary",
                "&:hover": {
                  bgcolor: isActive ? "primary.whiteSecound" : "primary.lightBlue",
                },
              }}
            >
              <Icon sx={{ fontSize: 22, color: isActive ? activeColor : "inherit" }} />
              {isActive && <Box component="span">{label}</Box>}
            </Button>
          </Tooltip>
        );
      })}
    </Box>
  );
}
